/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@agilepoint/web-components/loader';
defineCustomElements();
export const ApIcon = /*@__PURE__*/ createReactComponent('ap-icon');
export const ApIllustration = /*@__PURE__*/ createReactComponent('ap-illustration');
export const ApResolutionGuard = /*@__PURE__*/ createReactComponent('ap-resolution-guard');
export const ApSvgSprite = /*@__PURE__*/ createReactComponent('ap-svg-sprite');
//# sourceMappingURL=components.js.map